export default "__VITE_ASSET__BC4IL0S4__"